import * as actions from "./actions";
import _ from "underscore";
import update from "immutability-helper";

export let initialState = {
  fetching: false,
  fetched: false,
  error: null,
  registeringId: null,
  lastRegisteredId: null,
  registeringError: null,
  data: [],
  paymentsSent: { length: 0 },
  dca: {
    data: [],
    fetched: false,
    fetching: false,
    error: null,
  },
};

export let soldLoans = (state = initialState, action) => {
  switch (action.type) {
    case actions.SOLD_LOANS_FETCH_REQUEST:
      return Object.assign({}, state, {
        fetching: true,
      });
    case actions.SOLD_LOANS_FETCH_SUCCESS: {
      let filteredLoans = _.filter(action.response, (item) => {
        return item !== null;
      });

      return Object.assign({}, state, {
        fetching: false,
        fetched: true,
        data: filteredLoans,
      });
    }
    case actions.SOLD_LOANS_FETCH_ERROR:
      return Object.assign({}, state, {
        fetching: false,
        error: action.error,
      });
    case actions.SELL_LOAN_REQUEST:
      return Object.assign({}, state, {
        registeringId: action.additionalData.OCR,
      });
    case actions.SELL_LOAN_SUCCESS: {
      let initialData = [...state.data];
      let index = _.findIndex(initialData, (x) => {
        return x.OCR === action.additionalData.OCR;
      });

      return Object.assign({}, state, {
        registeringId: null,
        lastRegisteredId: action.additionalData.OCR,
        registeringError: null,
        data: [...initialData.slice(0, index), ...initialData.slice(index + 1)],
        paymentsSent: { length: state.paymentsSent.length + 1 },
      });
    }

    case actions.SELL_LOAN_ERROR:
      return Object.assign({}, state, {
        registeringId: null,
        registeringError: action.error,
      });

    case actions.CLEAR_PAYMENT_SENT_DATA: {
      return Object.assign({}, state, {
        paymentsSent: { length: 0 },
      });
    }

    case actions.DCA_INFO_FETCH_REQUEST: {
      return update(state, {
        dca: {
          fetching: { $set: true },
        },
      });
    }

    case actions.DCA_INFO_FETCH_SUCCESS: {
      return update(state, {
        dca: {
          fetching: { $set: false },
          fetched: { $set: true },
          data: { $set: action.response },
        },
      });
    }

    case actions.DCA_INFO_FETCH_ERROR: {
      return update(state, {
        dca: {
          fetching: { $set: false },
          error: { $set: action.error },
        },
      });
    }

    default:
      return state;
  }
};

export const SELL_LOAN_REQUEST = "SELL_LOAN_REQUEST";
export const SELL_LOAN_SUCCESS = "SELL_LOAN_SUCCESS";
export const SELL_LOAN_ERROR = "SELL_LOAN_ERROR";
